import React from "react";
import { Table } from "antd";
import { customPaginationStyle } from "./StaticTableAnt";

function loweFirstLetter(string) {
  return string?.charAt(0)?.toLowerCase() + string?.slice(1);
}

function ServerTableAnt({
  columns,
  data,
  setPageNo,
  setPageSize,

  count,
  setFilterValue,
  pageNo,
}) {
  const handleChange = (pagination, filters, sorter, extra) => {
    // console.log("params", sorter);
    const { field, order } = sorter;
    if (field !== undefined && order !== undefined) {
      const value = `${loweFirstLetter(field)}${
        order === "ascend" ? "asc" : "Desc"
      }`;
      setFilterValue(value);
    }
  };
  // const handleTableChange = (pagination) => {
  //   console.log("pagiantion", pagination);
  //   setPageSize(pagination.pageSize);
  //   setPageNo(pagination.current);
  // };
  // const valueData=data[0]!==undefined &&data[0]!==null &&data[0]?.Geo
  return (
    <div>
      <Table
        showSorterTooltip={false}
        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        columns={columns}
        dataSource={data}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50"],
          onChange: (page, pageSize) => {
            console.log("page", page);
            let pageNo = page - 1;
            setPageSize(pageSize);
            setPageNo(pageNo);
            // Handle the page size change here, fetch data based on the new page size
          },
          style: customPaginationStyle,
          // pageSize: count,
          total: count,
        }}
        onChange={handleChange}
        style={{ boxShadow: "7px 7px 20px lightgrey" }}
        scroll={{
          // x: 600,
          y: 500,
        }}
        responsive
      />
    </div>
  );
}

export default ServerTableAnt;
